import { createFileRoute } from '@tanstack/react-router';
import {
  AnalyticsEngagementPage,
  analyticsEngagementQueryOptions,
  analyticsLoaderDeps,
} from '@/features/analytics';

export const Route = createFileRoute('/_authed/analytics/engagement')({
  loaderDeps: ({ search }) => analyticsLoaderDeps(search),
  loader: ({ context, deps }) => {
    void context.queryClient.prefetchQuery(
      analyticsEngagementQueryOptions({
        period: deps.period,
      }),
    );
  },
  component: AnalyticsEngagementPage,
});
